<template>
  <div>
    <div>
      <div class="worker" @click="dialogTableVisible = true">
        <div v-if="choseStaffId == ''">
          <img src="@public/img/worker.png" alt="" />
          选择员工
        </div>
        <div v-else>员工：{{ showStaff }}</div>
      </div>
      <!-- <el-select v-model="choseStaff" placeholder="请选择">
        <el-option
          v-for="item in staffData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select> -->
      <div class="headline">选择油品</div>
      <div class="oil-list" :style="{height:oliHeight+'px'}">
        <template v-for="(item, index) in tableList">
          <div
            class="oil-item"
            :class="nowIdx == index ? 'oil-item_active' : ''"
            :key="index"
            @click="selectOil(index)"
          >
            <span>{{ item.name }}</span>
            <span>{{ item.goods.type.name }}{{ item.goods.name }}</span>
          </div>
        </template>
      </div>
      
    </div>

    <!-- 員工选择弹窗 -->
    <el-dialog title="选择员工" :visible.sync="dialogTableVisible">
      <div class="poPup">
        <div
          v-for="item in staffData"
          :key="item.id"
          :class="choseStaffId == item.id ? 'chose' : ''"
          @click="clickButton(item.id)"
        >
          {{ item.name }}（{{ item.id }}）
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { equipmentList } from '@/api/vip'
import { employeeList } from '@/api/employee'
import { mapGetters } from 'vuex'
import sidelistIntegral from './sidelistIntegral'

export default {
  props:{
    oliHeight:{
      type:Number,
      default:500
    }
  },
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  components: {
    sidelistIntegral,
  },
  data() {
    return {
      tabar: 'goods',
      dialogTableVisible: false,
      activeName: '选择油品',
      moneyTabs: ['选择油品'],
      tableList: [],
      staffData: [],
      choseStaff: '',
      nowIdx: 0,
      choseStaffId: '', //选择员工的id，
      showStaff: '',
    }
  },
  mounted() {
    this.getipmentList()
  },
  methods: {
    // 员工选择弹窗
    clickButton(id) {
      console.log('员工选择弹窗', id)
      this.choseStaffId = id
      this.showStaff = this.staffTitleTransiform(id)
      localStorage.setItem('choseStaffId', id)
      this.dialogTableVisible = false
      this.$parent.$refs.moneyPay.goPayMoney()
    },
    staffTitleTransiform(id) {
      let title = ''
      console.log('判断数据', this.staffData, id)
      this.staffData.forEach((item) => {
        if (item.id == Number(id)) {
          title = item.name + '(' + item.id + ')'
        }
      })
      return title
    },
    selectOil(idx) {
      this.nowIdx = idx
      this.$parent.oil_infor = this.tableList[idx]
      this.$parent.recount()
      console.log('999', this.tableList[idx])
    },
    getipmentList() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: '',
      }
      equipmentList(data).then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.tableList = res.data
            this.$parent.oil_infor = this.tableList[this.nowIdx]
            console.log(this.tableList)
          } else {
            this.$message.error('暂无数据....')
          }
        }
      })
      employeeList({ token: this.token, app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          this.staffData = res.data
          if (localStorage.getItem('choseStaffId')) {
            //
            this.choseStaffId = localStorage.getItem('choseStaffId')
            this.showStaff = this.staffTitleTransiform(this.choseStaffId)
          }
        }
        console.log('员工数据', res)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.oil-list{
  width: 100%;
  // height: 500px;
  overflow-y: auto;
}
.headline {
  height: 50px;
  line-height: 50px;
  padding-left: 14px;
}
.worker {
  height: 50px;
  background: #409eff;
  border-radius: 10px;
  padding-left: 14px;
  display: flex;
  color: #fff;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  img {
    height: 30px;
    margin-right: 10px;
  }
}
// 员工选择弹窗
.poPup {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  div {
    width: 180px;
    height: 60px;
    border-radius: 5px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 60px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .chose {
    background: #8cc5ff;
    color: #fff;
  }
}
.el-card {
  font-size: 16px;
  color: #ffffff;
  background: #f56c6c !important;
  .card-body {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    .order-item-info {
      display: flex;
      font-size: 14px;
      color: #f2f2f2;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
.oil-item {
  height: 50px;
  line-height: 50px;
  background: #f2f2f2;
  color: #22242f;
  cursor: pointer;
  font-size: 16px;
  align-items: center;
  padding-left: 10px;
  border-radius: 10px;
  margin-bottom: 15px;
  span:nth-child(1) {
    font-size: 20px;
  }
  span:nth-child(2) {
    margin-left: 10px;
  }
  span:nth-child(2) {
    margin-left: 10px;
  }
}
.user-radio {
  width: 50%;
  &-div {
    font-size: 24px;
    width: 100%;
  }
  &-p {
    font-size: 20px;
  }
  // 因为设置了scoped，所以固定的classname要用::v-deep操作
  div::v-deep {
    .el-radio-button__inner {
      border: none;
      //border-radius: 4px;
      background: #f2f2f6;
      width: 100%;
      height: 50px;
      line-height: 25px;
      text-align: center;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #00cd66;
    }
  }
}
.el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 20px;
}
.oil-item_active {
  background: #409eff;
  color: #f2f2f2;
}
</style>
